import axios from '@/utils'

// 碎片数量
export function pieceslist (data) {
    return axios({
        method: 'post',
        url: '/promote/pieceslist',
        data
    })
}

// 798猫库存
export function stock (data) {
    return axios({
        method: 'post',
        url: '/promote/798/stock',
        data
    })
}

//碎片抽奖
export function lottery (data) {
    return axios({
        method: 'post',
        url: '/promote/piece/lottery',
        data
    })
}

//碎片抽奖
export function union (data) {
    return axios({
        method: 'post',
        url: '/promote/piece/union',
        data
    })
}

//碎片抽奖
export function things (data) {
    return axios({
        method: 'post',
        url: '/promote/piece/things',
        data
    })
}

